import { useMatch, useNavigate } from "react-location";

import DuplicateTretyCurrencyContainer from "../duplicate-treaty-currency";
import LayerLimits from "../sections/layer-limits";
import { LocationGenerics } from "router/location";
import ParticipationOverview from "./sections/participation-overview";
import PortfolioStatment from "./sections/portfolio-statement";
import RemoveAdjustmentStatementContainer from "../remove-adjustment-statement";
import SendPlacingContainer from "../send-emails";
import { Show } from "components";
import TreatyAccounts from "./sections/quarters";
import TreatyAdjustmentStatment from "./sections/adjustment-statement";
import TreatyDetails from "./sections/treaty-overview";
import TreatyDocuments from "./sections/documents";
import TreatySurpluses from "./sections/surpluses";
import { TreatyType } from "_graphql/__generated__/globalTypes";
import ViewTreatySlipContainer from "../view-placing-slip";
import _ from "lodash";
import { useMemo } from "react";
import { useTreaty } from "hooks/data/use-treaties";
import { useUrlState } from "utils";

type Props = {
  allowQuarterlyFiling: boolean;
};

export default function TreatyOverview({ allowQuarterlyFiling }: Props) {
  const { params } = useMatch<LocationGenerics>();
  const navigate = useNavigate<LocationGenerics>();
  const [modal, setModal] = useUrlState("modal");

  const { loading, treaty } = useTreaty({
    treatyId: params.treaty || "",
  });

  const created = treaty?.treaty_np_detail?.adjustment_created;
  const isProportional = treaty?.treaty_program?.treaty_type === TreatyType.PROPORTIONAL;
  const allQuartersFiled = treaty?.treaty_accounts?.length === 4;
  const allowAdjustment: boolean = useMemo(() => {
    if (treaty?.treaty_participants?.length) {
      return treaty?.treaty_participants?.every(
        (el) => el?.treaty_participation_percentage
      );
    }
    return false;
  }, [treaty]);



  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 px-4 sm:px-6 items-start py-4 sm:py-8">
        <div className="md:col-span-2 grid gap-y-4">
          {/* Treaty Information section remains unchanged */}
          <TreatyDetails isProportional={isProportional} loading={loading} treaty={treaty} />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <TreatyDocuments />
            <Show if={!isProportional && allowAdjustment && treaty?.treaty_np_detail?.egrnpi !== undefined}>
              <TreatyAdjustmentStatment created={Boolean(created)} treaty={treaty} />
            </Show>
            <Show if={!loading && isProportional}>
              <TreatySurpluses treaty={treaty} />
            </Show>
          </div>

          {/* Portfolio Statement */}
          <Show if={allQuartersFiled}>
            <PortfolioStatment treaty={treaty} />
          </Show>
        </div>



        <div className="md:col-span-2 grid gap-y-4">
          {/* <TreatyDocuments /> */}
          <Show if={!loading && isProportional}>
            <TreatyAccounts treaty={treaty} />
          </Show>

          <Show if={!loading && !isProportional}>
            <LayerLimits treaty={treaty} />
          </Show>

          <ParticipationOverview treaty={treaty} isProportional={isProportional} />
        </div>

      </div>



      {
        modal && (
          <>
            <ViewTreatySlipContainer
              open={modal === "view"}
              setOpen={(val) => navigate({
                search: (prev) => ({
                  ...prev,
                  modal: val ? "view" : undefined,
                  id: undefined,
                }),
              })}
            />
            <SendPlacingContainer
              open={modal === "send"}
              setOpen={(val) => setModal(val ? "send" : undefined)}
            />
            <DuplicateTretyCurrencyContainer
              open={modal === "clone"}
              setOpen={(val) => setModal(val ? "clone" : undefined)}
            />
            <RemoveAdjustmentStatementContainer
              open={modal === "remove-adjustment-statement"}
              setOpen={(val) => setModal(val ? "clone" : undefined)}
            />
          </>
        )
      }
    </div >
  );
}
